import * as Yup from 'yup';

import { globalMessages } from '@savgroup-front-common/core/helpers';

const checkoutFormSchema = Yup.object().shape({
  name: Yup.string().required(globalMessages.form.required),
});

export default checkoutFormSchema;
